import groupApi from '@/api/group.api'

export const groupService = (function () {
  'use strict'


  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await groupApi.findAll(pageSize, pageNumber, headers, enterpriseIds)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await groupApi.findAll(undefined, undefined, headers, enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de grupos de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterpriseIds) {
    try {
      const response = await groupApi.getTotal(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un grupo con el id enviado como parámetro
   * @param {*} groupId
   */
  async function getGroup(groupId) {
    try {
        const response = await groupApi.getGroup(groupId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Devuelve los grupos con el id de empresa enviado como parámetro
   * @param {*} enterpriseId 
   */
  async function getGroupsByEnterpriseId(enterpriseId) {
    try {
      const response = await groupApi.getGroupsByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un grupo
   * @param {*} name
   */
  async function validateGroupName(name) {
    try {
      if (name) {
        const response = await groupApi.validateGroupName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un group
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await groupApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await groupApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await groupApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await groupApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nuevo grupo en la collection
   * @param {*} group
   * @param {*} thingIds
   */
  async function create(group, thingIds) {
    /*
    try {
      const response = await groupApi.create(group, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await groupApi.create(group, thingIds)
    return response.data
  }

  /**
   *  Actualiza un grupo existente en la collection
   * @param {*} group
   * @param {*} thingIds
   */
  async function update(group, thingIds) {
    /*
    try {
      const response = await groupApi.update(group, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await groupApi.update(group, thingIds)
    return response.data
  }

  return {
    findAll,
    getTotal,
    getGroup,
    validateGroupName,
    deleteOne,
    deleteMany,
    create,
    update,
    getGroupsByEnterpriseId
  }
})()
